import {
  catchError,
  concatMap,
  delay,
  finalize,
  first,
  map,
  mergeMap,
  repeat,
  retryWhen,
  takeUntil,
  takeWhile,
  tap,
} from 'rxjs/operators';
import { Component, Inject, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { NxDialogService, NX_MODAL_DATA } from '@aposin/ng-aquila/modal';
import { DownloadEvrotrustModalComponent } from '../download-evrotrust-modal/download-evrotrust-modal.component';
import { LocalStorageService } from 'ngx-localstorage';
import { Subject, Observable, switchMap, filter, of, throwError, EMPTY } from 'rxjs';
import { SessionStorageService } from 'ngx-webstorage';
import { GetDocumentsStatusUpdateEnum } from 'src/app/interfaces/evrotrust/get-documents-status.interface';
import { EvrotrustService } from 'src/app/shared/evrotrust.service';
import { SocketService } from 'src/app/shared/soket.service';
import { Client } from '@stomp/stompjs';
import { EvrotrustGeneralComponent } from '../evrotrust-general/evrotrust-general.component';

// interface SaveDocumentsToBpmInterface {
//   transactionID: string;
//   docId: string
//   threadID: string;
// }

@Component({
  selector: 'app-sign-policy-modal',
  templateUrl: './sign-policy-modal.component.html',
  styleUrls: ['./sign-policy-modal.component.scss'],
})
export class SignPolicyModalComponent implements OnInit, OnDestroy {
  @Inject(NX_MODAL_DATA) public data: any;
  private clickSignDocumetns$ = new Subject<void>();
  private saveDocumetsToBpm$ = new Subject<string>();
  private getDocumentsStatus$ = new Subject<string>();
  private unsubscribe$ = new Subject<void>();
  insurerNationalId$;
  insurerNationalId = '';
  policyRef$;
  isHaveValidAccount$: Observable<boolean>;
  isHaveValidAccountErrorMessage = false;
  showMessage = true;
  messageText;
  threadId;
  showWithdrawn;


  messagesArray = [
    {text: 'evrotrust.preparing-docs' , type:"message"},
    {text: 'evrotrust.look-at-evrotrust', type:"message"},
    {text: 'evrotrust.waiting-fot-feedback', type:"message"},
    {text: 'evrotrust.please-wait', type:"message"},
    {text: 'evrotrust.rejected', type:"error"},
    {text: 'evrotrust.error', type:"error"}
  ]

  msg: { egn: any; policyNum: any; threadId: any; };
  headers: { policyID: any; };
  clickedWithdrawn; 
  constructor(
    public dialogService: NxDialogService,
    private storage: LocalStorageService,
    private sessionStorage: SessionStorageService,
    public evrotrustService: EvrotrustService,
    private socketService: SocketService
  ) {}

  ngOnInit(): void {
    this.evrotrustService.isLoading = true;
    this.clickedWithdrawn=false;

    const data = this.storage.get('data');

    this.insurerNationalId$ = data.policyholderData.egn;
    this.insurerNationalId = data.policyholderData.egn;


    this.policyRef$ = data.sPlcNomer; 
     this.connect();

    this.evrotrustService.checkUser(this.insurerNationalId)
    .pipe(
    takeUntil(this.unsubscribe$),
    catchError(() => {
      this.evrotrustService.isLoading = false;
     this.socketService.Error();
      return EMPTY
    }),
    tap(res => {
      if (res===true){
        this.signDocuments()
      }
      else{
        this.evrotrustService.isLoading = false;
        this.dialogService.closeAll();
        this.downloadEvrotrustModal()
      }
    }
  )).subscribe();

    this.clickSignDocumetns$
      .pipe(
        takeUntil(this.unsubscribe$),
        tap((_) => {
          this.evrotrustService.isLoading = true
          this.messageText=this.messagesArray[0]
         }
        ),
        switchMap((_) =>
          this.evrotrustService.checkUser(this.insurerNationalId)
          .pipe(
            takeUntil(this.unsubscribe$),
             catchError(() => {
               this.evrotrustService.isLoading = false;
              //  this.messageText=this.messagesArray[4];
              this.socketService.Error();
              return EMPTY
             }),
             filter((res) => {
              if (res) {
                return true;
              } else {
                // show error message
                // stop loading spinner
                this.isHaveValidAccountErrorMessage = true;
                this.evrotrustService.isLoading = false;
                return false;
              }
            })
        )),
        tap((_)=> { this.dialogService.getModalById(this.dialogService.openModals[0].id).disableClose = true; }),
        switchMap((policyRef) =>
          this.evrotrustService.createDocumentsSigning(
            this.policyRef$,
            this.insurerNationalId
          ).pipe(
            takeUntil(this.unsubscribe$),
             catchError(() => {
               this.dialogService.getModalById(this.dialogService.openModals[0].id).disableClose = false;
               this.evrotrustService.isLoading = false;
              this.socketService.Error();
              return EMPTY
             }),
             tap((res:any) => {
              this.sessionStorage.store('threadID', res.threadID);
              // this.dialogService.getModalById(this.dialogService.openModals[0].id).disableClose = false;
              this.messageText=this.messagesArray[1];
              this.threadId = res.threadID
              if(this.socketService.socketClient.connected === true){
                this.sentMessages(this.getMessage());
              }
            })
        )
        ))
      .subscribe();
  }

  signDocuments() {
    this.showWithdrawn = false;
    this.threadId = "";
    this.clickSignDocumetns$.next();
  }
  downloadEvrotrustModal() {
    this.dialogService.closeAll();
    this.dialogService.open(DownloadEvrotrustModalComponent, {
      data: {
        evrotrust: true
       },
      showCloseIcon: true,
    });
  }

  getMessage(){
    return this.msg = {
      egn: this.insurerNationalId,
      policyNum: this.policyRef$,
      threadId : this.threadId
    }
  }

  connect(){
    this.headers = {
      "policyID": this.policyRef$
     };
        this.socketService.socketClient = new Client({
        brokerURL: this.socketService.url,
        connectHeaders: this.headers,
        onConnect: () => {
        this.getSubscription();
        },
      });

      this.socketService.socketClient.activate();

  }

  getSubscription() {
    this.socketService.wssubscription =  this.socketService.socketClient.subscribe('/user/check-documents-status',
      (message) => {
        let res = JSON.parse(message.body)
        if (res.statuses.statuses[1].groupIsProcessing === "1") {
                      this.messageText=this.messagesArray[2]
              }
              if(res?.errorDTO?.errorCode !== "0"){
                this.dialogService.getModalById(this.dialogService.openModals[0].id).disableClose = false;
                this.evrotrustService.isLoading = false;
                this.showWithdrawn = false;
                this.socketService.Error();
              }
              
              if(res.isProcessing == GetDocumentsStatusUpdateEnum.isProcessingNotReady){
                this.showWithdrawn = false;
              }
              if (res.status == GetDocumentsStatusUpdateEnum.isExpiredStatus) {
                this.sessionStorage.clear('threadId');
                this.evrotrustService.isLoading = false;
                // this.messageText=this.messagesArray[3]
                this.socketService.didNotAgreed()
                this.showWithdrawn = false;
                return false;
              }
              if (res.status == GetDocumentsStatusUpdateEnum.isPendingStatus) {
                this.showWithdrawn = true;
                return true;
              }
              if (
                res.status == GetDocumentsStatusUpdateEnum.isSignedStatus &&
                res.isProcessing ==
                  GetDocumentsStatusUpdateEnum.isProcessingReady
              ) {

                this.sessionStorage.clear('threadId');
                this.sessionStorage.store('transactionId', res.transactionId);
                this.dialogService.getModalById(this.dialogService.openModals[0].id).disableClose = false;
                this.dialogService.closeAll();
                this.evrotrustService.isLoading = false;
                this.successfulllySigned();
                return true;
              }
              if (
                res.status == GetDocumentsStatusUpdateEnum.isSignedStatus &&
                res.isProcessing ==
                  GetDocumentsStatusUpdateEnum.isProcessingNotReady
              ) {
                return true;
              }
              if (res.status == GetDocumentsStatusUpdateEnum.isRejectedStatus) {

                this.sessionStorage.clear('threadId');
                this.evrotrustService.isLoading = false;
                // this.messageText=this.messagesArray[3]
                this.socketService.didNotAgreed()
                this.showWithdrawn = false;

                return false;
              }
              if (res.status == GetDocumentsStatusUpdateEnum.isFailedStatus) {

                this.sessionStorage.clear('threadId');
                this.evrotrustService.isLoading = false;
                // this.messageText=this.messagesArray[4];
                this.socketService.Error();
                this.showWithdrawn = false;

                return false;
              }
              if (
                res.status == GetDocumentsStatusUpdateEnum.isWithdrawnStatus
              ) {
                this.sessionStorage.clear('threadId');
                this.evrotrustService.isLoading = false;
                // this.messageText=this.messagesArray[4];
                this.socketService.didNotAgreed();
                this.showWithdrawn = false;

                return false;
              }
              if (
                res.status == GetDocumentsStatusUpdateEnum.isUndeliverableStatus
              ) {
                this.sessionStorage.clear('threadId');
                this.evrotrustService.isLoading = false;
                // this.messageText=this.messagesArray[4];
                this.socketService.Error();
                this.showWithdrawn = false;


                return false;
              }
              if (res.status == GetDocumentsStatusUpdateEnum.isOnHoldStatus) {
                return true;
              }
      }, this.headers);
      this.sentMessages(this.getMessage());

    }

  sentMessages(message){
  
    this.socketService.socketClient.publish({ destination: '/message', body: JSON.stringify(message) });
  }

  withdrownnDocuments(){
    let chatMessage = {
      threadId : this.threadId,
      egn: this.insurerNationalId,
      policyNum: this.policyRef$,
      userCancel: true
    }
    this.sentMessages(chatMessage);
    this.messageText=this.messagesArray[3]

    this.showWithdrawn = false;
    this.clickedWithdrawn=true;
  }

  
  successfulllySigned(){
    this.dialogService.closeAll();
    this.dialogService.open(EvrotrustGeneralComponent, {
      width:'800px',
      data: {
       subheading: 'evrotrust.successful-signed'
      }, showCloseIcon: true
    });
  }

  ngOnDestroy(): void {
    this.evrotrustService.isLoading=false;
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if(this.socketService.wssubscription){
      this.socketService.wssubscription.unsubscribe();
      this.socketService.socketClient.deactivate();
    }}


}
